import React from 'react';
import {
  Typography,
  Grid,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { formatCurrency, formatNumber } from './formatters';

interface SummaryData {
  cfop: string;
  cst_icms: string;
  aliq_icms: number;
  base_calculo_icms: number;
  valor_icms: number;
  valor_icms_st: number;
  total_documentos: number;
}

interface DrillDownSummaryTableProps {
  resumo_cfop_aliquota: SummaryData[];
  title?: string;
  maxRows?: number;
}

const DrillDownSummaryTable: React.FC<DrillDownSummaryTableProps> = ({ 
  resumo_cfop_aliquota, 
  title = "Resumo por CFOP e Alíquota (até 20 registros)",
  maxRows = 10
}) => {
  const resumoData = resumo_cfop_aliquota || [];

  if (resumoData.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1" gutterBottom sx={{ mt: 3 }}>
        {title}
        <Chip 
          label={`${formatNumber(resumoData.length)} registros`} 
          size="small" 
          sx={{ ml: 1 }} 
          color="secondary"
          variant="outlined"
        />
      </Typography>
      
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>CFOP</strong></TableCell>
              <TableCell><strong>CST</strong></TableCell>
              <TableCell align="right"><strong>Alíquota</strong></TableCell>
              <TableCell align="right"><strong>Base Cálculo</strong></TableCell>
              <TableCell align="right"><strong>ICMS</strong></TableCell>
              <TableCell align="right"><strong>ICMS ST</strong></TableCell>
              <TableCell align="center"><strong>Docs</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {resumoData.slice(0, maxRows).map((resumo, index) => (
              <TableRow key={index} hover>
                <TableCell>
                  <Chip 
                    label={resumo.cfop}
                    color="primary"
                    size="small"
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>
                  <Chip 
                    label={resumo.cst_icms}
                    color="secondary"
                    size="small"
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" fontWeight={500}>
                    {formatNumber(resumo.aliq_icms)}%
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" color="primary.main">
                    {formatCurrency(resumo.base_calculo_icms)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" color="primary.main" fontWeight={500}>
                    {formatCurrency(resumo.valor_icms)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" color="warning.main">
                    {formatCurrency(resumo.valor_icms_st)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Chip
                    size="small"
                    label={formatNumber(resumo.total_documentos)}
                    color="info"
                    variant="filled"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default DrillDownSummaryTable; 